<section>
    <p>
        Awe snap! So you want the long story then. OK but it's a story fraught with disaster and treachery.
    </p>
    <p>
        Nah I'm just messing with you. I'm just a man who was born in Ohio. Grew up in Buffalo, NY and moved to Central Floride when I was 15. <br/>
    </p>
    <p>
        But you want to hear more about who I am not who I was.
    </p>
    <p>
        Currently you can find me working for <a href="https://mailgun.com">Mailgun</a>, as a Front-end Engineer or Software Engineer or React Engineer or developer or whatever the cool kids are call it these days, on the Deliverabilities/InboxReady team. <br/>
        Previously I was a Front-end Engineer working for <a href="https://madmobile.com">Mad Mobile</a> building out features for the Concierge MPOS(Mobile Point of Sale) application built with React.
    </p>
    <p>
        I went to a for profit tech school that no longer exists for unfortunate reasons. I graduated in 2008 and even though the school no longer exists I'm still paying for it.
        But I digress. One thing this school did do for me was introduce me to the entire world of digital media from Photoshop to Flash to basic HTML and CSS. Though not enough
        to do anything with just enough knowledge to spark the love and interest that pushed me to learn and then learn some more.
    </p>
</section>
<section>
    <h2>Here's a few things I know</h2>
    <div class="listContainer">
        <ul>
            <h3>Front End</h3>
            <li>HTML</li>
            <li>CSS/SCSS</li>
            <li>JavaScript/TypeScript</li>
            <li>React</li>
            <li>Svelte(what this here site was made with)</li>
        </ul>
        <ul>
            <h3>Back End</h3>
            <li>NodeJs</li>
            <li>Express</li>
            <li>Koa</li>
            <li>Fastify</li>
            <li>GraphQL</li>
            <li>Various ORMS and Databases</li>
        </ul>
    </div>
</section>

<style>
    section {
        text-align: left;
    }

    h2 {
        font-size: 1.2em;
        margin-bottom: 1em;
        margin-top: 2em;
        text-align: center;
        width: 100%;
    }

    .listContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
    }

    .listContainer h3 {
        margin: 0;
        margin-bottom: .8em;
    }

    .listContainer ul {
        padding: 0;
        width: 256px;
    }
</style>